function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.2888 3.86002L1.8188 18C1.64417 18.3024 1.55177 18.6453 1.55079 18.9945C1.54981 19.3438 1.64029 19.6872 1.81323 19.9905C1.98616 20.2939 2.23553 20.5468 2.53651 20.7239C2.83749 20.901 3.1796 20.9962 3.5288 21H20.4688C20.818 20.9962 21.1601 20.901 21.4611 20.7239C21.7621 20.5468 22.0114 20.2939 22.1844 19.9905C22.3573 19.6872 22.4478 19.3438 22.4468 18.9945C22.4458 18.6453 22.3534 18.3024 22.1788 18L13.7088 3.86002C13.5305 3.56613 13.2795 3.32314 12.98 3.15451C12.6805 2.98587 12.3425 2.89728 11.9988 2.89728C11.6551 2.89728 11.3171 2.98587 11.0176 3.15451C10.7181 3.32314 10.4671 3.56613 10.2888 3.86002V3.86002Z",
  stroke: "#F37A00",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 9V13",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 17H12.01",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgWarningIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning-icon.bc3ef240.svg";
export { ForwardRef as ReactComponent };